import adminRequest from 'services/adminRequest';

export function resourcesGetNews(token) {
    const url = `news`;
    return adminRequest(
        url,
        {
            method: 'GET',
        },
        false,
        token
    );
}

export function resourcesDeleteNews(token, id) {
    const url = `news?article_id=${id}`;
    return adminRequest(
        url,
        {
            method: 'DELETE',
        },
        false,
        token
    );
}

export function resourcesPutNews(token, id) {
    const url = `news`;
    return adminRequest(
        url,
        {
            method: 'PUT',
        },
        false,
        token
    );
}

export function resourcesPostNews(token, body) {
    const url = `news`;
    return adminRequest(
        url,
        {
            method: 'POST',
            data: JSON.stringify(body),
        },
        true,
        token
    );
}
